import { Controller } from "stimulus";

import("./component.scss")

const HIDDEN_CLASSNAME = "hidden"
const NOFADEOUT_CLASSNAME = "nofadeout"
const COLLAPSED_CLASSNAME = "collapsed"

export default class extends Controller {
  initialize() {
    super.initialize();
  }

  connect() {
    let self = this
    this.content_element = this.element.firstElementChild
    let toggle_button_id = "content_expander_" + this.content_element.id
    this.toggle_button = document.querySelector(`#${toggle_button_id}`)
    let toggle_button = this.toggle_button
    let content_element = this.content_element
    function handle_resize() {
      if(self.isOverflownHeight(content_element)){
        if(self.is_collapsed()){
          toggle_button.classList.remove(HIDDEN_CLASSNAME)
          content_element.classList.remove(NOFADEOUT_CLASSNAME)
        }
      } else {
        if(self.is_collapsed() && ! toggle_button.classList.contains(HIDDEN_CLASSNAME)) {
          toggle_button.classList.add(HIDDEN_CLASSNAME)
          content_element.classList.add(NOFADEOUT_CLASSNAME)
        }

      }
    }
    handle_resize()
    new ResizeObserver(handle_resize).observe(content_element)
  }

  toggle_extending(){
    if(this.is_collapsed()) {
      this.content_element.classList.remove(COLLAPSED_CLASSNAME)
      this.toggle_button.innerText = this.toggle_button.getAttribute("collapse-text")
    } else {
      this.content_element.classList.add(COLLAPSED_CLASSNAME)
      this.toggle_button.innerText = this.toggle_button.getAttribute("extend-text")
    }
  }

  is_collapsed(){
    return this.content_element.classList.contains(COLLAPSED_CLASSNAME)
  }

  isOverflownHeight(element) {
    // use one time the fontsize to only fadeout when not everything is visible
    var style = window.getComputedStyle(element, null).getPropertyValue('font-size');
    var fontSize = parseFloat(style);

    // if the last line is less than half visible, then the fold-out function should be available. therefor we devide the fontsize by 2
    fontSize = fontSize / 2;

    return element.scrollHeight > element.clientHeight + fontSize;
  }

}